module.exports = __webpack_public_path__ + "static/media/museosanscyrl.831df7b4.woff";


//////////////////
// WEBPACK FOOTER
// ./src/static/fonts/MuseoSansCyrl500/museosanscyrl.woff
// module id = 645
// module chunks = 0